<app-contact-person-basic-info [canAutoSave]="false">
</app-contact-person-basic-info>
